import emailjs from "emailjs-com";

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_ar8sg4k",
        "template_4d1ndvr",
        e.target,
        "z8iFWKZQj8w7CMA0m"
      )
      .then(
        (result) => {
          alert("submitted");
        },
        (error) => {
          alert("failed");
        }
      );

    e.target.reset();
  };
  return (
    <section id="contact">
      <h1 className="contact-heading">
        <i className="fa-solid fa-message"></i>
        <span>Get In Touch</span>
      </h1>
      <form
        className="contact-form"
        onSubmit={handleSubmit}
        data-aos="fade-zoom-in"
        data-aos-easing="ease-in-back"
        data-aos-delay="300"
        data-aos-offset="0"
        data-aos-duration="500"
      >
        <div className="contact-name-email">
          <input
            placeholder="Name"
            name="name"
            required
            autoComplete="off"
          ></input>
          <input
            type="email"
            placeholder="Email"
            name="email"
            required
            autoComplete="off"
          ></input>
        </div>
        <input
          placeholder="Subject"
          name="subject"
          required
          autoComplete="off"
        ></input>
        <textarea
          placeholder="Message"
          rows="4"
          name="message"
          required
          autoComplete="off"
        ></textarea>
        <button className="btn contact-btn btn-color" type="submit">
          Submit <i className="fa-solid fa-paper-plane"></i>
        </button>
      </form>
    </section>
  );
};

export default Contact;
